export { default } from './CarrosEletricosBannerImgButton';
